var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDepartmentStoreinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M5 16h54v43H5zm24 19a8 8 0 1 0-16 0"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M13 35h16v24H13zm36-5h1.25q-.312 2.423.625 2.423c.938 0 3.125.404 3.125 2.423s-1.875 3.492-1.875 6.462 1.563 4.038 1.563 6.865q0 2.827-1.563 2.827h-6.25q-1.563 0-1.563-2.827c0-2.827 1.563-3.896 1.563-6.865S44 36.865 44 34.846s2.188-2.423 3.125-2.423q.937 0 .625-2.423zm0 21v8M21 35v24M5 16V6h54v10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37 16v43"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M59 13v3a4 4 0 0 1-4 4h-4.125a4 4 0 0 1-3.242-1.657A4 4 0 0 1 44.391 20h-4.125a4 4 0 0 1-3.242-1.657A4 4 0 0 1 33.782 20h-4.125a4 4 0 0 1-3.242-1.657A4 4 0 0 1 23.173 20h-4.125a4 4 0 0 1-2.952-1.3 4 4 0 0 1-2.952 1.3H9.02a4 4 0 0 1-4-4V6H59z"
}))));
export default SvgDepartmentStoreinline;